<template>
  <main-content-layout title="Em Desenvolvimento...">
    <div style="height: 400px; color: #c1c1c1;" class="flex flex-center column">
      <q-icon name="mdi-hammer" size="190px"></q-icon>
      <h3 style="font-size: 20px; margin: 3px 20px">Em Desenvolvimento...</h3>
    </div>
   </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable } from 'jtech-webcomps'
import ServiceRequestValuesToCompensateController from './ServiceRequestValuesToCompensateController'
import ServiceRequestInvoiceController from '../ServiceRequestInvoiceController'
import ServiceRequestController from '../../../../ServiceRequestController'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'

import { QBtn } from 'quasar'

@Component({
  name: 'ServiceRequestValuesToCompensate',
  components: {
    MainContentLayout,
    QBtn,
    JtDataTable
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestValuesToCompensate extends Vue {
  invoiceController = ServiceRequestInvoiceController.getInstance();
  controller = ServiceRequestController.getInstance();
  valuesToCompensateController = ServiceRequestValuesToCompensateController.getInstance();
  data = [];
  columns = [];

  async mounted () {
    this.data = await this.invoiceController.valuesToCompensateFormByUnid()
    const headerForm = await this.valuesToCompensateController.loadValuesToCompensateForm()
    this.columns = headerForm[0].inputs[0].columns
    this.data = this.data.map((row) => {
      return { ...row, selected: false }
    })
  }

  get dataTable () {
    return this.data
  }

  availableStyle ({ col, props }) {
    return col.model === 'status'
      ? props.row[col.model]
        ? 'no-padding text-positive text-bold'
        : 'no-padding text-red text-bold'
      : 'no-padding '
  }

  sumValues (arr) {
    return arr.reduce(
      (accumulator, row) =>
        accumulator + this.$validarFloat(row),
      0
    )
  }

  get valuesToCompensateSum () {
    return this.sumValues(this.data.map(row => row.valuesToCompensate))
  }

  get compensatedValuesSum () {
    return this.sumValues(this.data.map(row => row.compensatedValues))
  }

  get resultingValueSum () {
    return this.sumValues(this.data.map(row => row.resultingValue))
  }
}
export default ServiceRequestValuesToCompensate
</script>
<style lang="stylus" scoped>

.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}

.top-area {
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.small-span {
  font-weight: 300
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
